import type {
  LanguageSettings,
  NotificationSettings,
  RecordingSettings,
  ProfileSettings,
  SecuritySettings,
} from '@/types'

export const profileSettings: ProfileSettings = {
  name: 'Varun Pandey',
  email: 'varun.pandey@pssgway.com',
  timeZone: 'Asia/Kolkata',
  interfaceLanguage: 'en',
  dailyDigest: true,
  emailOnActionAssigned: true,
}

export const languageSettings: LanguageSettings = {
  mode: 'identify',
  candidates: ['en-IN', 'hi-IN'],
  pinned: null,
  summaryLanguage: 'en',
  flagUntranslated: true,
}

/**
 * Defaults to `organizer-only` deliberately. For most attendees the summary
 * email is the first they hear that a recording existed, so the widest setting
 * is never the default.
 */
export const notificationSettings: NotificationSettings = {
  summaryRecipients: 'organizer-only',
  sendTiming: 'immediate',
  summaryEmailEnabled: true,
  failureAlertsEnabled: true,
  actionAssignedEnabled: true,
  weeklyDigestEnabled: false,
}

/** OFF, like every real workspace until an admin turns it on. */
export const recordingSettings: RecordingSettings = {
  screenCaptureEnabled: false,
}

export const securitySettings: SecuritySettings = {
  requireSso: true,
  enforceTwoFactorForAdmins: true,
  samlMetadataUrl: 'https://sso.pssgway.com/metadata',
  retention: { audioDays: 30, transcriptDays: 365, summaryDays: null },
}
